module.exports = __webpack_public_path__ + "img/DE01400.debebd13.png";